import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const ReturnPreviousPage = ({ text, handleClick }) => (
  <S.Container onClick={handleClick}>
    <S.Arrow>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <path
          d="M11.6667 9.16667V2.5L0 14.1667L11.6667 25.8333V19C20 19 25.8333 21.6667 30 27.5C28.3333 19.1667 23.3333 10.8333 11.6667 9.16667Z"
          fill="#93999C"
        />
      </svg>
    </S.Arrow>
    <S.Text>{text}</S.Text>
  </S.Container>
);

export default ReturnPreviousPage;

ReturnPreviousPage.defaultProps = {
  handleClick: () => {},
};

ReturnPreviousPage.propTypes = {
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};
